import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';

import {
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  FlowLimitTemperatureCommands,
  FlowLimitTemperatureProperties,
} from '@vi-iot/client';

import { GTMService } from '@services';
import { InstallationFeaturesStore } from '@store';

import { FlowLimitTempConfirmationDialogComponent } from '../flow-limit-temp-confirmation-dialog/flow-limit-temp-confirmation-dialog.component';

@Component({
  selector: 'app-flow-limit-temperature-panel',
  templateUrl: './flow-limit-temperature-panel.component.html',
  styleUrls: ['./flow-limit-temperature-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowLimitTemperaturePanelComponent implements OnInit {
  @Input() circuitId: string;

  readonly featurePropertyKey = FeaturePropertyKey;

  flowLimitTemperature$: Observable<
    Feature<FlowLimitTemperatureProperties, FlowLimitTemperatureCommands>
  >;
  onCancelFlowLimitTemperature$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private dialog: MatDialog,
    private gtmService: GTMService
  ) {}

  ngOnInit(): void {
    this.flowLimitTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.flowLimitTemperature(this.circuitId)
    );
  }

  onLimitFlowTempChange(value: number, feature: string, oldValue: number): void {
    const dialogRef = this.dialog.open(FlowLimitTempConfirmationDialogComponent, {
      width: '535px',
      data: {
        url: feature,
        value,
        oldValue,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((action) => {
      if (action.cancel) {
        this.onCancelFlowLimitTemperature$.next(false);
        setTimeout(() => {
          this.onCancelFlowLimitTemperature$.next(true);
        });
      }
    });

    this.gtmService.track('onSet', 'Limit flow temperature', 'heatingSchedule');
  }
}
